const style = (theme): any => ({
    mapWrapper: {
        width: '100%',
        height: '100%',
    },
    mapWrapperFixed: {
        position: 'fixed',
    },
});
export default style;
